// extracted by mini-css-extract-plugin
export default {"main":"_9a4f98ee95","tit":"_1d1ea62d4a","maintitle":"b1419469b0","ylw":"_2b3757da87","white":"_246873d935","mv_title":"_58c824fa0e","mv_nc":"_6779844c0c","mv_in":"ad5dbb4f6f"};